import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  employeetype: [],
  EmploymentTypeList: [],
  employeetypeids: null,
  maritalstatus: [],
  MaritalStatusList: [],
  maritalstatusids: null,
  creditmodetypeid: 2, // 0
  daysbefore: 0,
  isallowedinprobation: false,
  isallowhalfday: false,
  isfurtureappallowed: false,
  minleavecountforapp: 0,
  notifyinadvanceday: 0,
  notifynotbeforeday: 0,
  apppastday: 0,
  ispastappallowed: false,
  isleaveallowedinnotice: false,
  MonthsList: moment.monthsShort(),
};
class ImportantHolidays extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
    this.getEmploymentType();
    this.getMaritalStatus();
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      creditmodetypeid: this.state.creditmodetypeid,
      daysbefore: this.state.daysbefore,
      isallowedinprobation: this.state.isallowedinprobation,
      isallowhalfday: this.state.isallowhalfday,
      isfurtureappallowed: this.state.isfurtureappallowed,
      minleavecountforapp: this.state.minleavecountforapp,
      notifyinadvanceday: this.state.notifyinadvanceday,
      notifynotbeforeday: this.state.notifynotbeforeday,
      apppastday: this.state.apppastday,
      ispastappallowed: this.state.ispastappallowed,
      isleaveallowedinnotice: this.state.isleaveallowedinnotice,
      employeetypeids: this.state.employeetypeids
        ? this.state.employeetypeids.join()
        : this.state.employeetypeids,
      maritalstatusids: this.state.maritalstatusids
        ? this.state.maritalstatusids.join()
        : this.state.maritalstatusids,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      this.setState({
        ParentIndex,
        leavetypeid: props.leavetypeid,
        creditmodetypeid:
          props.InitLeavesPolicy.policy[ParentIndex].creditmodetypeid,
        daysbefore: props.InitLeavesPolicy.policy[ParentIndex].daysbefore,
        isallowhalfday:
          props.InitLeavesPolicy.policy[ParentIndex].isallowhalfday,
        isfurtureappallowed:
          props.InitLeavesPolicy.policy[ParentIndex].isfurtureappallowed,
        minleavecountforapp:
          props.InitLeavesPolicy.policy[ParentIndex].minleavecountforapp,
        notifyinadvanceday:
          props.InitLeavesPolicy.policy[ParentIndex].notifyinadvanceday,
        notifynotbeforeday:
          props.InitLeavesPolicy.policy[ParentIndex].notifynotbeforeday,
        apppastday: props.InitLeavesPolicy.policy[ParentIndex].apppastday,
        ispastappallowed:
          props.InitLeavesPolicy.policy[ParentIndex].ispastappallowed,
        isleaveallowedinnotice:
          props.InitLeavesPolicy.policy[ParentIndex].isleaveallowedinnotice,
        isallowedinprobation:
          props.InitLeavesPolicy.policy[ParentIndex].isallowedinprobation,
      });
    } else {
      this.setState({ ...ParentState }, () => {
        this.getEmploymentType();
        this.getMaritalStatus();
      });
    }
  }

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language
        ? this.props.Language.extratimepolicy[key]
        : "",
    });
  };

  getEmploymentType() {
    instance.get(`/superuser/getmastercode/EmploymentType`).then(
      (result) => {
        const policyDet =
          this.props.InitLeavesPolicy.policy[this.state.ParentIndex];
        const EmploymentTypeList = result.data.result;
        if (EmploymentTypeList.length > 0) {
          EmploymentTypeList.unshift({ displayname: "All", displayvalue: 0 });
        }
        let ids = null;
        if (policyDet) {
          ids = policyDet.employeetypeids;
          ids = ids && ids.split(",");
        }
        this.setState(
          {
            EmploymentTypeList,
            // employeetypeids: policyDet ? typeof policyDet.employeetypeids === 'string' ? JSON.parse(policyDet.employeetypeids) : policyDet.employeetypeids : null
            employeetypeids: ids,
          },
          () => {
            const { employeetypeids } = this.state;
            const employeetype = [];
            if (employeetypeids) {
              for (const id of employeetypeids) {
                const filterObj = this.state.EmploymentTypeList.find(
                  (x) => x.displayvalue == id,
                );
                employeetype.push(filterObj);
              }
            }
            this.setState({ employeetype });
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  getMaritalStatus() {
    instance.get(`/superuser/getmastercode/MaritalStatus`).then(
      (result) => {
        const policyDet =
          this.props.InitLeavesPolicy.policy[this.state.ParentIndex];
        const MaritalStatusList = result.data.result;
        if (MaritalStatusList.length > 0) {
          MaritalStatusList.unshift({ displayname: "All", displayvalue: 0 });
        }
        let ids = null;
        if (policyDet) {
          ids = policyDet.maritalstatusids;
          ids = ids && ids.split(",");
        }
        this.setState(
          {
            MaritalStatusList,
            // maritalstatusids: policyDet ? typeof policyDet.maritalstatusids === 'string' ? JSON.parse(policyDet.maritalstatusids) : policyDet.maritalstatusids : null
            maritalstatusids: ids,
          },
          () => {
            const { maritalstatusids } = this.state;
            const maritalstatus = [];
            if (maritalstatusids) {
              for (const id of maritalstatusids) {
                const filterObj = this.state.MaritalStatusList.find(
                  (x) => x.displayvalue == id,
                );
                maritalstatus.push(filterObj);
              }
            }
            this.setState({ maritalstatus });
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  handleChange(name, ...arg) {
    switch (name) {
      case "employeetype":
      case "maritalstatus": {
        let filterObj = arg[0] && arg[0].findIndex((x) => x.displayvalue == 0);
        if (filterObj != null && filterObj >= 0) {
          switch (name) {
            case "employeetype":
              filterObj = this.state.EmploymentTypeList.filter(
                (x) => x.displayvalue != 0,
              );
              break;
            case "maritalstatus":
              filterObj = this.state.MaritalStatusList.filter(
                (x) => x.displayvalue != 0,
              );
              break;
            default:
              break;
          }
          this.setState({ [name]: filterObj }, () => {
            this.multiOptions(name, filterObj);
          });
        } else {
          this.setState(
            { [name]: arg[0] && arg.length > 0 ? arg[0] : [] },
            () => {
              this.multiOptions(name, arg[0] && arg.length > 0 ? arg[0] : []);
            },
          );
        }
        break;
      }
      case "creditmodetypeid": {
        this.setState(
          { [name]: arg[0], daysbefore: 0, isallowedinprobation: false },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      }
      case "isallowedinprobation":
      case "isallowhalfday":
      case "isleaveallowedinnotice":
        this.setState({ [name]: arg[0] }, () => {
          this.UpdateReducer();
        });
        break;
      case "isfurtureappallowed":
        this.setState(
          {
            [name]: arg[0],
            minleavecountforapp: 0,
            notifyinadvanceday: 1,
            notifynotbeforeday: 2,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      case "ispastappallowed":
        this.setState({ [name]: arg[0], apppastday: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      default:
        break;
    }
  }

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max) ||
        Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else {
        value = Number(event.target.value);
      }
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  multiOptions(name, arg) {
    const obj = [];
    for (const val of arg) {
      obj.push(val.displayvalue);
    }
    switch (name) {
      case "employeetype":
        this.setState({ employeetypeids: obj }, () => this.UpdateReducer());
        break;
      case "maritalstatus":
        this.setState({ maritalstatusids: obj }, () => this.UpdateReducer());
        break;
      default:
        break;
    }
  }

  render() {
    const language = this.props.Language.impholidays;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          <div className="margin-top-20">
            <p className="form-main-header">
              <FormattedMessage
                id="LbCalculationsDisbursal"
                defaultMessage="Who, How & When (Calculations & Disbursal)"
              />
            </p>
            <p className="form-sub-header">
              <FormattedMessage
                id="LbWhocanAvail"
                defaultMessage="Who can avail this leave balance?"
              />
            </p>
            <div className="inner-wrapper opaque">
              <div className="margin-bottom-20">
                <p className="form-input-label">
                  <FormattedMessage
                    id="LbEmploymentType"
                    defaultMessage="Employment Type"
                  />
                </p>
                <Select
                  className="form-control width60"
                  autofocus
                  placeholder="Select Employment Type"
                  isMulti
                  options={this.state.EmploymentTypeList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.handleChange.bind(this, "employeetype")}
                  value={this.state.employeetype}
                />
              </div>
              <div className="margin-bottom-20">
                <p className="form-input-label">
                  <FormattedMessage
                    id="LbMaritalStatus"
                    defaultMessage="Marital Status"
                  />
                </p>
                <Select
                  className="form-control width60"
                  autofocus
                  placeholder="Select Marital Status"
                  isMulti
                  options={this.state.MaritalStatusList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.handleChange.bind(this, "maritalstatus")}
                  value={this.state.maritalstatus}
                />
              </div>
            </div>
            <div className="inner-wrapper opaque">
              <p className="form-sub-header">
                <FormattedMessage
                  id="LbAvailableForUse"
                  defaultMessage="When will the leave balance be available for employees to use?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("creditmodetypeid", 1)}
                aria-expanded={this.state.creditmodetypeid == 1}
              >
                <span>
                  <FormattedMessage
                    id="LbCreditSpecificDay"
                    defaultMessage="Credit Leave balance on the specific date"
                  />
                </span>
                {this.state.creditmodetypeid == 1 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.creditmodetypeid == 1}
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <div>
                    <InputValues
                      min="1"
                      max="365"
                      field="daysbefore"
                      onChange={this.CommonNumberChange.bind(
                        this,
                        "daysbefore",
                        365,
                      )}
                      value={this.state.daysbefore}
                      defaultvalue={this.state.daysbefore}
                    />

                    <FormattedMessage
                      id="LbDaysBeforeImpDay"
                      defaultMessage="days before the important date"
                    />
                  </div>
                  <div className="margin-top-20">
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="__LbCreditDuringProbation"
                        defaultMessage="Do you want to allow credit during Probation?"
                      />
                    </p>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isallowedinprobation", true)
                      }
                      aria-expanded={this.state.isallowedinprobation}
                    >
                      <span>
                        <FormattedMessage id="LbYes" defaultMessage="Yes" />
                      </span>
                      {this.state.isallowedinprobation == true ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected " />
                      )}
                    </div>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isallowedinprobation", false)
                      }
                      aria-expanded={!this.state.isallowedinprobation}
                    >
                      <span>
                        <FormattedMessage id="LbNo" defaultMessage="No" />
                      </span>
                      {this.state.isallowedinprobation == false ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected " />
                      )}
                    </div>
                  </div>
                </Collapse>
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("creditmodetypeid", 2)}
                aria-expanded={this.state.creditmodetypeid == 2}
              >
                <span>
                  <FormattedMessage
                    id="LbCreditAllAtOnce"
                    defaultMessage="Leave balance will be credited all at once"
                  />
                </span>
                {this.state.creditmodetypeid == 2 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.creditmodetypeid == 2}
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <div>
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="__LbCreditDuringProbation"
                        defaultMessage="Do you want to allow credit during Probation?"
                      />
                    </p>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isallowedinprobation", true)
                      }
                      aria-expanded={this.state.isallowedinprobation}
                    >
                      <span>
                        <FormattedMessage id="LbYes" defaultMessage="Yes" />
                      </span>
                      {this.state.isallowedinprobation == true ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected " />
                      )}
                    </div>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isallowedinprobation", false)
                      }
                      aria-expanded={!this.state.isallowedinprobation}
                    >
                      <span>
                        <FormattedMessage id="LbNo" defaultMessage="No" />
                      </span>
                      {this.state.isallowedinprobation == false ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected " />
                      )}
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
          <div className="margin-top-20">
            <p className="form-main-header">
              <FormattedMessage
                id="LbUsagePolicy"
                defaultMessage="Usage Policy"
              />
            </p>
            <p className="form-sub-header">
              <FormattedMessage
                id="LbConfigureLeaveUsage"
                defaultMessage="Now, let’s configure the leave usage policy below"
              />
            </p>
            <div className="inner-wrapper opaque margin-top-10">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbAllowHalfDayApplication"
                  defaultMessage="Would you like to allow half-day leave applications?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isallowhalfday", true)}
                aria-expanded={this.state.isallowhalfday == true}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.isallowhalfday == true ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isallowhalfday", false)}
                aria-expanded={this.state.isallowhalfday == false}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.isallowhalfday == false ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
            </div>
            {/* 3 */}
          </div>
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbLimitFutureApplications"
                defaultMessage="Do you want to limit leave applications for future dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", true)}
              aria-expanded={this.state.isfurtureappallowed == true}
            >
              <span>
                {" "}
                <FormattedMessage id="LbYes" defaultMessage="Yes" />{" "}
              </span>
              {this.state.isfurtureappallowed == true ? (
                <span className="floatright">
                  {" "}
                  <img src={CheckImg} height="20" />{" "}
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.isfurtureappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <FormattedMessage
                  id="LbLeaveDurationGreater"
                  defaultMessage="If leave duration is greater than"
                />
                <InputValues
                  min="0"
                  max="365"
                  field="minleavecountforapp"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "minleavecountforapp",
                    365,
                  )}
                  value={this.state.minleavecountforapp}
                  defaultvalue={this.state.minleavecountforapp}
                />

                <span>days, </span>
                <br />
                <FormattedMessage
                  id="__LbApplicationMustBe"
                  defaultMessage="employee must apply for a leave  atleast"
                />
                <InputValues
                  min="1"
                  max="365"
                  field="notifyinadvanceday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifyinadvanceday",
                    365,
                  )}
                  value={this.state.notifyinadvanceday}
                  defaultvalue={this.state.notifyinadvanceday}
                />
                <span>days in advance,</span>
                <br />
                <FormattedMessage
                  id="__LbButNotEarlier1"
                  defaultMessage="but not earlier than"
                />

                {/* <FormattedMessage id="__LbApplicationMustBe" defaultMessage="days, employee must apply for a leave  atleast" /><br />
                                <InputValues
                                    min="1"
                                    max="365"
                                    field="notifyinadvanceday"
                                    onChange={this.CommonNumberChange.bind(this, "notifyinadvanceday", 365)}
                                    value={this.state.notifyinadvanceday}
                                    defaultvalue={this.state.notifyinadvanceday}
                                />
                                <FormattedMessage id="LbButNotEarlier1" defaultMessage="days in advance, but not earlier than" /> */}
                <InputValues
                  min={
                    (this.state.notifyinadvanceday &&
                      parseInt(this.state.notifyinadvanceday) + 1) ||
                    2
                  }
                  //   min={this.state.notifyinadvanceday && this.state.notifyinadvanceday}
                  max="365"
                  field="notifynotbeforeday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifynotbeforeday",
                    365,
                  )}
                  value={this.state.notifynotbeforeday}
                  defaultvalue={this.state.notifynotbeforeday || 2}
                />

                <FormattedMessage id="LbDays" defaultMessage="days" />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", false)}
              aria-expanded={this.state.isfurtureappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isfurtureappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbPastApplications"
                defaultMessage="Do you want to allow leave application for past dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("ispastappallowed", true)}
              aria-expanded={this.state.ispastappallowed == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.ispastappallowed == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.ispastappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <FormattedMessage
                  id="LbApplMadeUpTo"
                  defaultMessage="Leave application can be made upto"
                />
                <InputValues
                  min="1"
                  max="90"
                  field="apppastday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "apppastday",
                    90,
                  )}
                  value={this.state.apppastday}
                  defaultvalue={this.state.apppastday}
                />

                <FormattedMessage
                  id="LbActualLeaveDate"
                  defaultMessage="days after actual leave date"
                />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("ispastappallowed", false)}
              aria-expanded={this.state.ispastappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.ispastappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbLeaveDuringNotice"
                defaultMessage="Do you want to allow the use of leaves during notice period?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isleaveallowedinnotice", true)}
              aria-expanded={this.state.isleaveallowedinnotice == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.isleaveallowedinnotice == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isleaveallowedinnotice", false)}
              aria-expanded={this.state.isleaveallowedinnotice == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isleaveallowedinnotice == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
ImportantHolidays.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ImportantHolidays)));
